import logo_stockwatch from "../img/logo_stockwatch.webp";
import logo_lapatisserie from "../img/logo_lapatisserie.webp";
import logo_stockapp from "../img/logo_stockapp.webp";
import logo_interact from "../img/logo_interact.webp";
import logo_placescanner from "../img/logo_placescanner.webp";
import logo_twitterfeel from "../img/logo_twitterfeel.webp";
import logo_neuralnetwork from "../img/logo_neuralnetwork.webp";
import logo_covid from "../img/logo_covid.webp";
import logo_ABCtopic from "../img/logo_ABCtopic.webp";

const projects = [
  {
    id: 1,
    name: "PlaceScanner",
    image: logo_placescanner,
    tag: ["NodeJS", "Express", "Pug", "API"],
    github: "https://github.com/ivypratiwi/PlaceScanner",
    video: "https://www.youtube.com/embed/AXlHa2VOaqI",
    summary:
      "The main purpose of this web app is to search and provide knowledge from the pictures of popular landmarks across the nations. The user will upload a landmark image. In return, the user will get information on the places from an image which have been uploaded to the web app. The information will be in the form of a Youtube video with a map to show the exact location of the landmark. This app was created using NodeJS and Express for its back-end and Pug templating engine for the front-end. There are four APIs used in this app: Google Cloud Vision API, Open Street Map API, Youtube API and Google Maps API",
  },
  {
    id: 2,
    name: "La Patisserie",
    image: logo_lapatisserie,
    tag: ["Python", "Flask", "MySQL", "Jinja"],
    github: "https://github.com/ivypratiwi/lapatisserie",
    video: "https://www.youtube.com/embed/usqFliHMotI",
    summary:
      "La Patisserie is a fictitional e-commerce patisserie shop. User can search for cakes and make orders directly from the website. The webpage aims to give customers convenience to view all cakes by its types and the best-selling cakes in the store. It allows users to filter by the cake types, show the detail of each cake and allow users to make order from the shopping basket. The project mainly used python flask for its back-end, jinja, html, css, bootstrap for the front-end, and mySQL for its database.",
  },
  {
    id: 3,
    name: "TwitterFeel",
    image: logo_twitterfeel,
    tag: ["AWS", "NodeJS", "React"],
    github: "https://github.com/ivypratiwi/twitterfeel",
    video: "https://www.youtube.com/embed/HNPcf3XRgxE",
    summary:
      "TwitterFeel is a web app which utilise a massive amount of data from Twitter API to analyse and retrieve in-depth information from a Twitter user account. This application will allow people to find out how active a Twitter account post their tweets, what is the sentiment for each tweet, how the sentiment moves changes across the previous months, and what are the common tweet topics from a Twitter account. This app uses AWS storage services such as S3 bucket and ElastiCache to store the data, ReactJS for the front-end, NodeJS and Express for the back-end. The app was initially deployed to AWS with Auto Scaling Group and Load Balancer settings.",
  },

  {
    id: 4,
    name: "StockWatch",
    image: logo_stockwatch,
    tag: ["React", "JavaScript", "ChartJS"],
    github: "https://github.com/ivypratiwi/stockwatch_v2",
    video: "https://www.youtube.com/embed/ImIhweNvZxc",
    summary:
      "The main idea of StockWatch Web Application is to give users convenience in retrieving stocks data. StockWatch aims to provide the basic functionality to users by having various features such as searching by stock symbol, searching by industry, filtering by dates and chart. UseEffect is used when calling the API to avoid consecutive calling to API.  On top of this, the webpage can be viewed in different devices.",
  },
  {
    id: 5,
    name: "StockApp",
    image: logo_stockapp,
    tag: ["React Native", "JavaScript"],
    github: "https://github.com/ivypratiwi/stockmobileapp_v2",
    video: "https://www.youtube.com/embed/Ylbw1b5ivSQ",
    summary:
      "StockApp is a mobile application to search for stocks. This mobile app is built using React Native and Expo. The app retrieved data from API using useEffect and filter the stocks data of the selected companies. User can add the stocks to their stock watchlist. Async Storage is used to store the users' stock watchlist on their mobile device. If the user shuts down the app, their watchlist will still be available.",
  },
  {
    id: 6,
    name: "Interact",
    image: logo_interact,
    tag: ["JavaScript", "HTML", "CSS"],
    github: "https://github.com/ivypratiwi/inter-act",
    summary:
      "This project is a team project developed during QUT Colab. QUT Colab was an event to design innovative solutions to learning and teaching problems through design thinking, ideating, prototyping, testing and pitching. Our team's idea was placed in the top three projects and progressed to a higher level of development. Interact is a platform to create a supportive environment for international students at QUT. This platform will share meaningful experiences and insights from the experienced students to encourage active learning in QUT. This project is built using HTML, CSS and JavaScript.",
  },
  {
    id: 7,
    name: "Diabetes Classification",
    image: logo_neuralnetwork,
    tag: ["Neural Network", "DT", "Explainable AI"],
    github: "https://github.com/ivypratiwi/diabetes_classification",
    summary:
      "This project aims to create a model to predict whether a patient has diabetes from analysing the patient's features. The dataset is processed in two different machine learning algorithms; decision tree and neural network. Hyperparameters are tuned for both of models to effectively train the model. The performance of both models will be compared to derive to the best model. Furthermore, explainable AI using LIME library is used to understand how the neural network model make prediction. This project used some machine learning libraries such as TensorFlow Keras and SciKit Learn to make the classification.",
  },
  {
    id: 8,
    name: "Hospital Clustering ",
    image: logo_covid,
    tag: ["K-Means", "Data Science"],
    github: "https://github.com/ivypratiwi/hospital_clustering",
    summary:
      "This project aims to perform clustering analysis for over six thousand hospitals in USA. The result from this project will show the utilisation rate for different categories of hospitals by performing K-means clustering. The distribution of the clusters are visualised using the distribution plot and pairplot.",
  },
  {
    id: 9,
    name: "ABC News Topics",
    image: logo_ABCtopic,
    tag: ["Topic Analysis", "NLTK", "NMF"],
    github: "https://github.com/ivypratiwi/topic_modelling",
    summary:
      "This project analysed the top news headlines topics in Australia. Each of the news headline will be analysed using NMF topic modelling algorithm to cluster the keywords. The cluster of keywords will be used to derive the topic title. Each words in the news headline are tokkenized and lemmatized. From the analysis of topic frequency, this report found that Australia top three news topics are government policies, sports and accidents. Australians were interested in the news which may affect their daily lives such as new rules from its government.",
  },
];

export default projects;
